export default __webpack_public_path__ + "static/media/Quizzes_comp_.9f3c646d.png";